import { useUserDataclasses } from '@/hooks/user/use-user-dataclasses';
import type { SyntheticEvent } from 'react';
import { SelectMenu } from '@/components/select-menu';

export function CreateNewObjectForm({
  onSubmit,
  type
}: {
  onSubmit: (event: SyntheticEvent) => void;
  type?: string;
}) {
  const { data } = useUserDataclasses(type);

  const filteredDataClasses = data?.dataClasses.filter(
    (dc) => dc.schemaType === 'data' || (type === 'vault' && dc.schemaType === 'vaultItem') || (type === 'user' && dc.schemaType === 'user')
  );

  return (
    <div>
      <form onSubmit={onSubmit}>
        <div className="flex items-end space-x-2">
          <div className="flex-1">
            {filteredDataClasses && (
              <SelectMenu
                label=""
                options={filteredDataClasses}
                name="dataclass"
                selected={filteredDataClasses[0]}
              />
            )}
          </div>
          <button
            type="submit"
            className="mt-3 inline-flex w-full items-center justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:ml-3 sm:mt-0 sm:w-auto self-end  dark:bg-indigo-900 dark:text-indigo-100 dark:hover:bg-indigo-700"
          >
            Create
          </button>
        </div>
      </form>
    </div>
  );
}
